module.exports = __webpack_public_path__ + "static/media/glass.2ac5a5d2.png";